import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button} from 'react-bootstrap'
import cx from 'classnames'
import {autocompleteMatcher, provideAutocompleteMatcher, displayPrediction, highlightPrediction, addressField} from '../../core/google/places'
import {connectLoadingLock} from '../../core/redux/loading'
import {buttonField} from '../../core/redux/form'
import Icon from '../../core/components/Icon'
import Card from '../../core/components/Card'
import TypeaheadInput from '../../core/components/TypeaheadInput'
import StaticMap from '../../core/components/StaticMap'
import ButtonToggle from '../../core/components/ButtonToggle'
import PatrimonyPicker from '../../patrimony/components/PatrimonyPicker'
import AgencyPicker from '../../company/components/AgencyPicker'
import config from '../../config'
import {updateOpenTicketCmd} from '../actions'
import i18n from '../i18n'
import style from './OpenTicketAddressCard.less'

const GEO_LOCATION_DISTANCE = 500

function provideFullAutocompleteMatcher(address) {
    const input = address && (address.zipCode + ' ' + address.city)
    return provideAutocompleteMatcher({input})
}

class OpenTicketAddressCard extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        form: PropTypes.func.isRequired,
        cmd: PropTypes.object,
        split: PropTypes.bool
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {cmd} = this.props

        const address = cmd && cmd.ticket && cmd.ticket.address
        const zipCode = address && address.zipCode
        const placeId = (address && address.street) && address.checker && address.checker.googlePlaceId
        const geoLocation = (address && address.street) && address.geoLocation && {...address.geoLocation, distance: GEO_LOCATION_DISTANCE}
        const regionAutoCompleteMatcher = provideAutocompleteMatcher({types: ['(regions)']})
        const fullAutocompleteMatcher = provideFullAutocompleteMatcher(address)
        this.setState({zipCode, placeId, geoLocation, regionAutoCompleteMatcher, fullAutocompleteMatcher})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.cmd && nextProps.cmd != this.props.cmd) {
            if (nextProps.cmd.ticket != (this.props.cmd && this.props.cmd.ticket)
                && nextProps.cmd.ticket.address != (this.props.cmd && this.props.cmd.ticket && this.props.cmd.ticket.address)) {
                const {cmd} = nextProps
                
                const address = cmd && cmd.ticket && cmd.ticket.address
                const zipCode = address && address.zipCode
                const placeId = (address && address.street) && address.checker && address.checker.googlePlaceId
                const geoLocation = (address && address.street) && address.geoLocation && {...address.geoLocation, distance: GEO_LOCATION_DISTANCE}
                this.setState({zipCode, placeId, geoLocation})

                if (!address) {
                    const regionAutoCompleteMatcher = provideAutocompleteMatcher({types: ['(regions)']})
                    this.setState({regionAutoCompleteMatcher})
                }
                if (!(address && address.street)) {
                    const fullAutocompleteMatcher = provideFullAutocompleteMatcher(address)
                    this.setState({fullAutocompleteMatcher})
                }
            }
        }

        if (nextProps.patrimonyStream != this.props.patrimonyStream) {
            const {dispatch, patrimonyStream} = nextProps

            if (patrimonyStream.length == 0) {
                dispatch(updateOpenTicketCmd({locationRef: {locationReferenceType: 'AgencyLocation'}}))
            }
        }
    }

    render() {
        const {dispatch, form, cmd, authenticated, patrimonyStream, split, ...others} = this.props
        const {zipCode, placeId, geoLocation, regionAutoCompleteMatcher, fullAutocompleteMatcher} = this.state

        const header = (
            <h5>{i18n.interventionLocation}</h5>
        )

        const regionAddressTypeaheadButton = () => {
            if (cmd && cmd.ticket && cmd.ticket.address) {
                return (
                    <Button
                        {...buttonField(form.ticket.address(), null)}>
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }
            return (
                <Button>
                    <Icon icon='plus' size='xs' />
                </Button>
            )
        }

        const fullAddressTypeaheadButton = () => {
            if (cmd && cmd.ticket && cmd.ticket.address && cmd.ticket.address.street) {
                const {zipCode, city, country} = cmd.ticket.address

                return (
                    <Button
                        {...buttonField(form.ticket.address(), {zipCode, city, country})}>
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }
            return (
                <Button>
                    <Icon icon='plus' size='xs' />
                </Button>
            )
        }

        const addressTypeaheadAddon = (text) => (
            <span className={style.step}>{text}</span>
        )


        const displayPatrimonyAddress = (address) => {
            return address && (
                <span>{address.number} {address.street}, {address.zipCode} {address.city}</span>
            )
        }

        const displayPatrimony = (patrimony, mode) => {
            if (mode == 'Picked') {
                return (
                    <div>
                        <div className={style.map}>
                            <StaticMap info
                                apiKey={config.google.apiKey}
                                ratio={16/9}
                                identify={(a) => a.geoLocation}
                                value={[...patrimony.addresses, ...patrimony.complementaryAddresses]} />
                        </div>
                        <div className={style.patrimony}>
                            <h4>
                                <small>{patrimony.ref + ' - ' + patrimony.label}</small>
                                {displayPatrimonyAddress([...patrimony.addresses, ...patrimony.complementaryAddresses][0])}
                            </h4>
                        </div>
                    </div>
                )
            }

            return (
                <span className={style.patrimony}>
                    <small>{patrimony.ref + ' - ' + patrimony.label}</small>
                    {displayPatrimonyAddress([...patrimony.addresses, ...patrimony.complementaryAddresses][0])}
                </span>    
            )
        }

        const full = (field) => {
            const disabled = !(cmd && cmd.ticket && cmd.ticket.address && cmd.ticket.address.zipCode)
            return {...field, disabled}
        }

        return (
            <div>
                <Card
                    kind='tab'
                    header={header}
                    {...others}>
                    <div className={cx({[style.split]: split})}>
                        <Row>
                            <Col sm={split && 6 || 12}>
                                <div className={style.main}>
                                    <form>
                                        <Row>
                                            <Col xs={12}>
                                                <TypeaheadInput
                                                    ref='typeahead'
                                                    source={regionAutoCompleteMatcher}
                                                    display={displayPrediction}
                                                    highlight={highlightPrediction}
                                                    placeholder={i18n.addAddressCity + ' *'}
                                                    buttonAfter={regionAddressTypeaheadButton()}
                                                    addonBefore={addressTypeaheadAddon(1)}
                                                    {...addressField(form.ticket.address())} />
                                            </Col>
                                            <Col xs={12}>
                                                <TypeaheadInput
                                                    ref='typeahead'
                                                    source={fullAutocompleteMatcher}
                                                    display={displayPrediction}
                                                    highlight={highlightPrediction}
                                                    placeholder={i18n.addAddressStreet + ' *'}
                                                    buttonAfter={fullAddressTypeaheadButton()}
                                                    addonBefore={addressTypeaheadAddon(2)}
                                                    {...full(addressField(form.ticket.address()))} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={4}>
                                                <Input disabled
                                                    type='text'
                                                    name='number'
                                                    placeholder={i18n.addressNumber}
                                                    {...form.ticket.address.number()} />
                                            </Col>
                                            <Col xs={8}>
                                                <Input disabled
                                                    type='text'
                                                    name='street'
                                                    placeholder={i18n.addressStreet}
                                                    {...form.ticket.address.street()} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={4}>
                                                <Input disabled
                                                    type='text'
                                                    name='zipCode'
                                                    placeholder={i18n.addressZipCode}
                                                    {...form.ticket.address.zipCode()} />
                                            </Col>
                                            <Col xs={8}>
                                                <Input disabled
                                                    type='text'
                                                    name='city'
                                                    placeholder={i18n.addressCity}
                                                    {...form.ticket.address.city()} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={4}>
                                                <Input
                                                    type='text'
                                                    name='digicode'
                                                    placeholder={i18n.addressDigicode}
                                                    {...form.ticket.address.digicode()} />
                                            </Col>
                                            <Col xs={4}>
                                                <Input
                                                    type='text'
                                                    name='staircase'
                                                    placeholder={i18n.addressStaircase}
                                                    {...form.ticket.address.staircase()} />
                                            </Col>
                                            <Col xs={4}>
                                                <Input
                                                    type='text'
                                                    name='floor'
                                                    placeholder={i18n.addressFloor}
                                                    {...form.ticket.address.floor()} />
                                            </Col>
                                        </Row>
                                    </form>
                                </div>
                            </Col>
                            <Col sm={split && 6 || 12}>
                                <ButtonToggle
                                    {...form.locationRef.locationReferenceType()}>
                                    <Button
                                        bsStyle='link'
                                        value='PatrimonyLocation'>
                                        {i18n.patrimony}
                                    </Button>
                                    <Button
                                        bsStyle='link'
                                        value='AgencyLocation'>
                                        {i18n.agency}
                                    </Button>
                                </ButtonToggle>
                                {cmd && cmd.company && form.locationRef.patrimonyUid && (
                                    <PatrimonyPicker
                                        size='small'
                                        contact={cmd.ticket && cmd.ticket.callerz && cmd.ticket.callerz.uid}
                                        company={cmd.company}
                                        zipCode={zipCode}
                                        placeId={placeId}
                                        geoLocation={geoLocation}
                                        display={displayPatrimony}
                                        {...form.locationRef.patrimonyUid()} />
                                )}
                                {cmd && cmd.company && form.locationRef.agencyUid && (
                                    <AgencyPicker
                                        user={authenticated}
                                        company={cmd.company}
                                        {...form.locationRef.agencyUid()} />
                                )}
                            </Col>
                        </Row>
                    </div>
                </Card>
            </div>
        )
    }
}

OpenTicketAddressCard = connectLoadingLock()(OpenTicketAddressCard)

OpenTicketAddressCard = connect((state) => ({
    loading: state.loading,
    authenticated: state.user.authenticated,
    patrimonyStream: state.patrimony.stream
}))(OpenTicketAddressCard)

export default OpenTicketAddressCard


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketAddressCard.js